import { addInlineAttachment } from '../actions/addInlineAttachment';
import { mutator } from 'satcheljs';

mutator(addInlineAttachment, actionMessage => {
    const { attachmentWell, inlineAttachment } = actionMessage;
    attachmentWell.inlineAttachments.push(inlineAttachment);
});
